var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from "react";
import useModernLayoutEffect from "use-isomorphic-layout-effect";
export var SafeReact = __assign({}, React);
export function contains(parent, child) {
    var _a;
    if (!parent || !child) {
        return false;
    }
    var rootNode = (_a = child.getRootNode) === null || _a === void 0 ? void 0 : _a.call(child);
    // First, attempt with faster native method
    if (parent.contains(child)) {
        return true;
    }
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && isShadowRoot(rootNode)) {
        var next = child;
        while (next) {
            if (parent === next) {
                return true;
            }
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
export function getDocument(node) {
    return (node === null || node === void 0 ? void 0 : node.ownerDocument) || document;
}
export function isMouseLikePointerType(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    var values = ["mouse", "pen"];
    if (!strict) {
        values.push("", undefined);
    }
    return values.includes(pointerType);
}
export function createAttribute(name) {
    return "data-floating-ui-".concat(name);
}
export function clearTimeoutIfSet(timeoutRef) {
    if (timeoutRef.current !== -1) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = -1;
    }
}
export function useLatestRef(value) {
    var ref = React.useRef(value);
    useModernLayoutEffect(function () {
        ref.current = value;
    });
    return ref;
}
var useInsertionEffect = SafeReact.useInsertionEffect;
var useSafeInsertionEffect = useInsertionEffect || (function (fn) { return fn(); });
export function useEffectEvent(callback) {
    var ref = React.useRef(function () {
        if (__DEV__) {
            throw new Error("Cannot call an event handler while rendering.");
        }
    });
    useSafeInsertionEffect(function () {
        ref.current = callback;
    });
    return React.useCallback(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([ref], args, false));
    }, []);
}
